import React, { useCallback, useEffect, useState } from 'react';

import Iframe from './Iframe';

const isSSR = typeof window === 'undefined';
const HtmlSrcPath = '/html/2b2e4b_d767b483cae16e027c4ea8ac7906fbf4.html';

type IframeHtmlProps = {
  html: string;
  iframeSandboxDomain: string;
  isViewer: boolean;
  onHeightChange: (height: number) => void;
};

export const IframeHtml: React.FC<IframeHtmlProps> = ({
  html,
  onHeightChange,
  iframeSandboxDomain,
  isViewer,
}) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isIFrameLoaded, setIsIFrameLoaded] = useState(false);
  const [currId] = useState(Math.random().toString(36).substr(2, 9));
  const strippedUrl = iframeSandboxDomain.replace(/\/$/, '');
  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  const handleIframeMessage = ({
    data,
  }: {
    data: { type: string; id: string; height: number };
  }) => {
    const { type, id, height } = data;
    if (type === 'htmlPlugin:heightResize' && id === currId) {
      onHeightChange(height);
    }
  };

  useEffect(() => {
    setShouldRender(true);
    !isSSR && window.addEventListener('message', handleIframeMessage);

    return () => {
      !isSSR && window.removeEventListener('message', handleIframeMessage);
    };
  }, []);

  const updateIframeContent = (content: string) => {
    iframeRef.current?.contentWindow?.postMessage(
      { type: 'htmlPlugin:updateContent', id: currId, content },
      '*'
    );
  };

  useEffect(() => {
    if (!isIFrameLoaded) {
      return;
    }

    updateIframeContent(html);
  }, [html, isIFrameLoaded]);

  const handleIframeLoad = useCallback(() => {
    setIsIFrameLoaded(true);
  }, []);

  return shouldRender ? (
    <Iframe
      style={{ backgroundColor: 'transparent' }}
      onLoad={handleIframeLoad}
      iframeRef={iframeRef}
      isViewer={isViewer}
      src={strippedUrl + HtmlSrcPath}
    />
  ) : null;
};
